import type { ReactNode } from "react";
import { useCurrentQuestions } from "@pulse/hooks/surveyHooks";
import { QuestionContext } from "./QuestionContext";

export function QuestionProvider({
    children,
    questionId,
    idx,
}: {
    children: ReactNode;
    questionId: number;
    idx: number;
}) {
    const question = useCurrentQuestions().data?.find((q) => q.id === questionId);

    if (!question) {
        throw new Error(`Question with id ${questionId} not found`);
    }

    return (
        <QuestionContext.Provider value={{ question, idx }}>{children}</QuestionContext.Provider>
    );
}
